module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 1-f49ca280cef9b75d4628eea287e3ad94.png";